import {
    Pipe,
    PipeTransform,
} from "@angular/core";
import { UserBonus } from "@Front-end/seed/models/user";

@Pipe({
    name: "bonusPercent",
    standalone: true,
})
export class BonusPercentPipe implements PipeTransform {

    public transform(bonus: UserBonus): string {
        return (bonus.rollover_pct).toFixed();
    }

}
